import { Button, VbzDropzone, VbzInputText } from '@smiles/voebiz-ui-kit';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState, ChangeEvent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useTransactions } from 'contexts/Transactions';
import { Tooltip } from 'components/Tooltip';
import { postCSVFileAndCampaingName } from '../../services/services';
import DrawerModal from '../DrawerModal';
import ErrorModalBatch from '../ErrorModalBatch';
import SearchCPFModal from '../SearchCPFModal';
import InstructionsModalBatch from '../InstructionsModalBatch';
import IncludeModalButtons from '../IncludeModalButtons';
import ErrorModalIndividual from '../ErrorModalIndividual';
import SuccessModalIndividual from '../SuccessModalIndividual';
import LoadedFile from '../LoadedFile';
import Loader from '../Loader';
import SuccessModalBatch from '../SuccessModalBatch';
import ConfirmationModalBatch from '../ConfirmationModalBatch';

interface Props {
  isOpen: boolean;
  closeModal(): void;
  type: string;
  setTab(tab: string): void;
  instructionsModal?: boolean;
  modalType?: 'team' | 'clients' | 'default';
}

const ModalInclude = ({ isOpen, closeModal, type, setTab, instructionsModal = false, modalType }: Props) => {
  const { t } = useTranslation(['beneficiaries', 'includeTeam']);

  const { milesRange, isActive, rewardCustomersIsEnabled } = useTransactions();

  const [selectedFile, setSelectedFile] = useState<File[]>([]);

  const [isInstructionsActive, setIsInstructionsActive] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [showSuccessModalBatch, setShowSuccessModalBatch] = useState(false);

  const [securityError, setSecurityError] = useState(true);

  const [showErrorModalBatch, setShowErrorModalBatch] = useState(false);
  const [showTransactionFormIndividual, setShowTransactionFormIndividual] = useState(false);

  const [showSuccessModalIndividual, setShowSuccessModalIndividual] = useState(false);

  const [showConfirmationModalBatch, setshowConfirmationModalBatch] = useState(false);

  const [showErrorModalIndividual, setShowErrorModalIndividual] = useState(false);

  const [errorTypeIndividual, setErrorTypeIndividual] = useState<
    'cpfNotRegister' | 'innactiveAccount' | 'generalError'
  >('cpfNotRegister');

  const [cpfAlreadyExists, setCpfAlreadyExists] = useState(false);

  const [base64, setBase64] = useState<string | ArrayBuffer | null>();

  const [name, setName] = useState('');

  const [campaingName, setCampaingName] = useState('');

  const [cpfValue, setCpfValue] = useState('');

  const [birthday, setBirthday] = useState<Dayjs | null>(null);

  const [email, setEmail] = useState('');

  const [filename, setFilename] = useState('');

  const [searchParams] = useSearchParams();

  async function handleSendCSVFileAndCampaingName() {
    const isClient = modalType === 'clients';
    setIsLoading(true);
    postCSVFileAndCampaingName(base64 as string, campaingName, isClient)
      .then((response) => {
        setshowConfirmationModalBatch(false);
        if (response.success) {
          setShowSuccessModalBatch(true);
        } else if (response.data.code === 0o1) {
          setSecurityError(true);
          setShowErrorModalBatch(true);
        } else {
          setSecurityError(false);
          setShowErrorModalBatch(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const openConfirmationModal = () => {
    setshowConfirmationModalBatch(true);
  };

  const getBase64 = (file: File[]) => {
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onload = () => {
      setBase64(reader.result);
    };
  };
  const handleCloseModal = () => {
    closeModal();
    setCpfValue('');
    setTab('one');
    setSelectedFile([]);
    setCampaingName('');
    setShowTransactionFormIndividual(false);
    setIsInstructionsActive(false);
    setShowSuccessModalBatch(false);
    setShowErrorModalBatch(false);
    setshowConfirmationModalBatch(false);
    setShowSuccessModalIndividual(false);
    setShowErrorModalIndividual(false);
    searchParams.delete('m');
  };
  const handleSuccessModalIndividualClick = () => {
    setShowSuccessModalIndividual(false);
    closeModal();
    setCpfValue('');
  };
  const handleSuccessModalIndividualClickOut = () => {
    setShowSuccessModalIndividual(false);
  };
  const handleErrorModalIndividual = () => {
    cpfAlreadyExists && closeModal();
    setShowErrorModalIndividual(false);
    setCpfValue('');
  };
  const handleErrorModalBatch = () => {
    setShowErrorModalBatch(false);
    setSelectedFile([]);
  };
  const handleSuccessModalBatch = () => {
    setSelectedFile([]);
    setIsInstructionsActive(false);
    setShowSuccessModalBatch(false);
  };

  const closeConfirmationModalBatch = () => {
    setshowConfirmationModalBatch(false);
  };

  const handleBackButtonClick = () => {
    closeModal();
    setTab('one');
    setShowTransactionFormIndividual(false);
  };
  const handleShowInstructions = () => setIsInstructionsActive(true);
  const handleClearFile = () => setSelectedFile([]);
  const modalValidation =
    !isInstructionsActive &&
    !showSuccessModalBatch &&
    !showErrorModalBatch &&
    !showSuccessModalIndividual &&
    !showErrorModalIndividual &&
    !showConfirmationModalBatch;
  const showInstructionsModalBatch =
    (isInstructionsActive && !showSuccessModalBatch && !showErrorModalBatch) || instructionsModal;

  function messageError() {
    const typeModal = modalType === 'team' ? 'Equipe' : 'Clientes';

    if (!rewardCustomersIsEnabled) {
      return null;
    }

    if (
      (!isActive.isActiveForClients && modalType === 'clients') ||
      (!isActive.isActiveForTeam && modalType === 'team')
    ) {
      return (
        <div className="reward-inactive" data-testid="reward-inactive">
          <div className="vbz-icon-beneficiaries-large-reward-inactive" />
          <h3 className="reward-inactive__title">{t('includeTeam:reward_inactive_title', { type: typeModal })}</h3>
          <span className="reward-inactive__description">
            <Trans
              i18nKey="includeTeam:reward_inactive_description"
              values={{ type: typeModal }}
              components={{ strong: <strong /> }}
            />
          </span>
        </div>
      );
    }
    return null;
  }

  useEffect(() => {
    if (selectedFile.length !== 0) {
      getBase64(selectedFile);
    }
  }, [selectedFile]);

  const handleCampaingNameInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setCampaingName(inputValue);
  };

  const getModalTitle = () => {
    if (modalType === 'team') {
      return t('includeTeam:reward_team');
    }
    if (modalType === 'clients') {
      return t('includeTeam:reward_clients');
    }
    return 'Enviar milhas em lote';
  };

  const isTransactionIndividual = type === 'one';
  const shouldShowTabs = modalValidation && !instructionsModal && !showErrorModalIndividual && isActive;
  return (
    <DrawerModal id="include-beneficiary-modal" open={isOpen} anchor="right" onClose={handleCloseModal}>
      <div className="include-modal-container">
        {messageError()}
        {!messageError() && shouldShowTabs && (
          <>
            {!showTransactionFormIndividual && (
              <>
                <div className="tabs">
                  <span
                    className={isTransactionIndividual ? 'tab-title-active' : 'tab-title'}
                    onClick={() => setTab('one')}
                  >
                    {t('single')}
                  </span>
                  <span
                    className={!isTransactionIndividual ? 'tab-title-active' : 'tab-title'}
                    onClick={() => setTab('many')}
                  >
                    {t('batch')}
                  </span>
                </div>
              </>
            )}
            {isTransactionIndividual ? (
              <SearchCPFModal
                milesRange={milesRange}
                cpfValue={cpfValue}
                setCpfValue={setCpfValue}
                setErrorTypeIndividual={setErrorTypeIndividual}
                setShowErrorModalIndividual={setShowErrorModalIndividual}
                setShowSuccessModalIndividual={setShowSuccessModalIndividual}
                showTransactionFormIndividual={showTransactionFormIndividual}
                setShowTransactionFormIndividual={setShowTransactionFormIndividual}
                modalType={modalType}
              />
            ) : (
              <div data-testid="test-uploader">
                <h4 className="include-one-search__description_title">{getModalTitle()}</h4>
                <IncludeModalButtons handleShowInstructions={handleShowInstructions} />
                {selectedFile?.length === 0 ? (
                  <VbzDropzone
                    extensions={['text/plain']}
                    textExtensions={t('modalInclude:csv_file')}
                    textDesktop={t('modalInclude:select_files')}
                    textMobile={t('modalInclude:select_files_mobile')}
                    cbOnFilesAdded={(file) => setSelectedFile(file)}
                  />
                ) : (
                  <>
                    <LoadedFile selectedFile={selectedFile} handleClearFile={handleClearFile} />
                    <VbzInputText
                      value={campaingName}
                      onChange={handleCampaingNameInputChange}
                      placeholder={t('modalInclude:campaing_name_placeholder')}
                      textLabel={
                        <>
                          Nome da campanha
                          <Tooltip content="Use esse campo para identificar os envios" direction="top">
                            <div className="vbz-icon-beneficiaries-tooltip-icon" />
                          </Tooltip>
                        </>
                      }
                      id="campaing-name-input-many"
                    />
                  </>
                )}
                <div className="btn-wrapper-confirmation">
                  <button type="button" className="back-text-btn" onClick={handleBackButtonClick}>
                    Voltar
                  </button>
                  <Button
                    onClick={openConfirmationModal}
                    disabled={selectedFile.length < 1 || campaingName.length < 1}
                    className="include-button-form"
                    data-testid="test-include-button"
                  >
                    {isLoading ? <Loader small /> : 'Enviar pedido'}
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
        {showInstructionsModalBatch && (
          <div>
            <InstructionsModalBatch milesRange={milesRange} />
            {!instructionsModal && (
              <button type="button" className="back-button" onClick={() => setIsInstructionsActive(false)}>
                {t('includeTeam:go_back')}
              </button>
            )}
          </div>
        )}
        {showSuccessModalBatch && <SuccessModalBatch toggleSuccesModal={handleSuccessModalBatch} filename={filename} />}

        {showConfirmationModalBatch && (
          <ConfirmationModalBatch
            toggleConfirmationModal={closeConfirmationModalBatch}
            // eslint-disable-next-line react/jsx-no-bind
            sendCSVFileAndCampaingName={handleSendCSVFileAndCampaingName}
            isLoading={isLoading}
          />
        )}

        {showSuccessModalIndividual && (
          <SuccessModalIndividual
            toggle={handleSuccessModalIndividualClick}
            toggleOut={handleSuccessModalIndividualClickOut}
          />
        )}
        {showErrorModalIndividual && (
          <ErrorModalIndividual
            toggle={handleErrorModalIndividual}
            errorType={errorTypeIndividual}
            modalType={modalType}
          />
        )}
        {showErrorModalBatch && (
          <ErrorModalBatch
            toggleErrorModal={handleErrorModalBatch}
            securityError={securityError}
            milesRange={milesRange}
          />
        )}
      </div>
    </DrawerModal>
  );
};

export default ModalInclude;
